import { bindFunctions } from '@app/utils/class'
import * as React from 'react'
import {
  Button,
  Col,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from 'reactstrap'
import {
  actionCreators,
  ICriticalDatesEditState,
} from '../modules/criticalDatesEdit'
import { IDevelopmentCriticalDatesDocument } from '@app/models/DevelopmentCriticalDatesDocument'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatDate, humanize } from '@app/utils/formatting'
import { IDueDiligenceItem } from '@app/models/DueDiligenceItem'

interface IComponentProps {
  criticalDatesDoc: IDevelopmentCriticalDatesDocument
}
type QuickAddModalProps = ICriticalDatesEditState &
  IComponentProps &
  typeof actionCreators

export class CriticalDatesEditModal extends React.PureComponent<QuickAddModalProps> {
  private formRef: React.RefObject<HTMLFormElement>

  constructor(props: QuickAddModalProps) {
    super(props)

    this.formRef = React.createRef()

    bindFunctions(this)
  }

  public render() {
    const criticalDates = this.props.criticalDatesDoc.criticalDates
    return (
      <Form>
        <Button
          color='link'
          className='d-print-none'
          size='lg'
          title='Edit Dates'
          onClick={() => this.showModal()}
        >
          <FontAwesomeIcon icon={['fal', 'sliders-h']} fixedWidth />
        </Button>
        <Modal
          isOpen={this.props.isOpen}
          toggle={this.props.closeCriticalDatesEdit}
          size='lg'
        >
          <ModalHeader toggle={this.props.closeCriticalDatesEdit}>
            Edit Critical Dates
          </ModalHeader>
          <ModalBody className='d-flex place-content-between w-1/2'>
            <Col>
              <Row>
                <Col md={5}>
                  <Label className='d-flex'>Date Offset</Label>
                  <Label>Positive to add days</Label>
                  <Label>Negative to remove days</Label>
                  <Input
                    type='number'
                    step='1'
                    placeholder={'Enter amount'}
                    onChange={(e) => {
                      this.props.setOffset(e.target.valueAsNumber)
                    }}
                  ></Input>
                </Col>
              </Row>
              <Label className='pt-4'>Preview</Label>
              <Table size='sm' striped>
                <thead>
                  <tr>
                    <th />
                    <th>Critical Dates</th>
                    <th>Responsibility</th>
                    <th>Date</th>
                    <th>New Date</th>
                  </tr>
                </thead>
                <tbody>
                  {criticalDates.map((criticalDate, index) => (
                    <tr key={index}>
                      <td style={{ width: '24px' }}>
                        {criticalDate!.isComplete && (
                          <FontAwesomeIcon
                            className='text-primary'
                            icon={['fas', 'check']}
                            fixedWidth
                          />
                        )}
                      </td>
                      <td>{criticalDate!.title}</td>
                      <td>{humanize(criticalDate!.responsibility)}</td>
                      <td>
                        {formatDate(criticalDate!.dueDate, 'MM/DD/YYYY', 'TBD')}
                      </td>
                      <td>
                        {formatDate(
                          this.props.offset && !criticalDate!.isComplete
                            ? criticalDate!.dueDate! + this.props.offset * 86400
                            : criticalDate!.dueDate,
                          'MM/DD/YYYY',
                          'TBD',
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Col>
          </ModalBody>
          <ModalFooter>
            <Button
              color='secondary'
              onClick={() => {
                this.props.closeCriticalDatesEdit()
              }}
            >
              Cancel
            </Button>

            <Button
              color='primary'
              onClick={() => {
                this._onSave()
              }}
              disabled={this.props.isSaving || !this.props.offset}
            >
              Save
            </Button>
          </ModalFooter>
        </Modal>
      </Form>
    )
  }

  private showModal() {
    this.props.showCriticalDatesEdit(this.props.offset)
    this._reloadData()
  }

  private _reloadData() {
    if (this.formRef.current) {
      this.formRef.current.forceReloadData()
    }
  }

  private _onSave() {
    this.props.saveCriticalDatesEdit(
      this.props.offset,
      this.props.criticalDatesDoc.criticalDates,
    )
    this.props.resetState()
  }
}
